
import { gsap, Expo, Power4 } from "gsap";
import { Backdrop } from "exports-loader?exports=Backdrop!bootstrap/js/src/util/backdrop";
import calculHeightHeader from "./calculHeightHeader";

        

const Default = {
    backdrop: true,
}

const CLASS_NAME_BACKDROP = 'search-backdrop'; // mettre une seule class


export class searchToggle {


    /**
    * Constructs a new parallax instance.
    *
    * @param container Where parallax applies to.
    */

    constructor(CSSSelector, config) {
        this.selector = CSSSelector;

        this.reset();

        this._config = this._getConfig(config)
        this._backdrop = this.initializeBackDrop()
        this._iconClose = document.querySelectorAll('.toggler-search-js .icon-close');
        this._iconSearch = document.querySelectorAll('.toggler-search-js .icon-search');
        this._header = document.querySelector('.nav-desktop');
        this._topBar = document.querySelector('.top--bar');
        this._search = document.querySelector('.search--panel');
        this._elementSearch = document.querySelectorAll('.search--panel .search--wrapper');

        this._navDesktop = document.querySelector('.nav-desktop');
        this._navMobile = document.querySelector('.nav-mobile');

   
        this._tl = gsap.timeline();

        this._tl.set([this._header, this._topBar], {clearProps:"all"})

        this._tl
            .to([this._header, this._topBar], 0.5, { backgroundColor: 'rgba(255, 255, 255, 1)' })
            .add('searchOpen')
            .to([this._header, this._topBar], 1, {
                color: '#000', ease:
                    Expo.easeOut
            }, '0.1')
            .to(this._search, 0.1, { opacity: 1, ease: Power4.easeOut }, 'searchOpen-=20%')
            .to(this._search, 1, { yPercent: 0, y: 0, ease: Power4.easeOut }, 'searchOpen-=20%')
            .add('panelOpen')
            .to(this._iconSearch, 0.5, { opacity: 0 }, 'searchOpen-=20%')
            .to(this._iconClose, 0.5, { scale: 1, opacity: 1 }, 'searchOpen-=20%')
            .fromTo(this._elementSearch, 1, { y: -20, opacity: 0 }, { y: 0, opacity: 1 }, 'panelOpen-=60%')
        this._tl.pause();
    }


    // Private

    _getConfig(config) {
        config = {
            ...Default
        }
        return config
    }


    initializeBackDrop() {
        return new Backdrop({
            className: CLASS_NAME_BACKDROP,
            isVisible: true,
            isAnimated: true,
            rootElement : "#wrapper"
            // clickCallback: () => this.hide()
        })
    }

    /**
   * Find elements
   * @return {void}
   */
    findElements() {
        this.els = document.querySelectorAll(this.selector);
    }

    /**
   * Reset Find any elements
   * @return {void}
   */
    reset() {
        let headerHeight = calculHeightHeader();
        document.querySelector('.search--panel').style.top = headerHeight[2] + 'px';

        // necessaire de regarder si on change en sticky sur la home 
        const target = document.querySelector('.fixed-header')
        const options = {
            attributes: true
        }
        function callback(mutationList) {
            mutationList.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (mutation.target.classList.contains('sticky')) {
                        document.querySelector('.search--panel').style.top = headerHeight[3] + 'px';
                    } else {
                        document.querySelector('.search--panel').style.top = headerHeight[2] + 'px';
                    }
                }
            })
        }

        const observer = new MutationObserver(callback)
        observer.observe(target, options)

        this.findElements();
        this.initializeBackDrop();
        this.toggle();
        this.closeBtnOverlay();
    }

    toggle() {
        for (let item of this.els) {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                if (this._tl.reversed() || this._tl.paused()) {
                    this.openSearch();
                } else {
                    this.closeSearch();
                }

                this.closeBtnOverlay();
            })
        }
    }

    openSearch() {
        this._tl.timeScale(1);
        this._backdrop.show();
        this._tl.play();
    }

    closeSearch() {
        this._tl.timeScale(2);
        this._tl.reverse();
        this._backdrop.hide();
    }


    // on click overlay
    closeBtnOverlay() {
        const overlay = document.querySelector('.' + CLASS_NAME_BACKDROP);
        if (overlay) {
            overlay.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeSearch();
            });
        }
    }




}

